/**
* 基础菜单 API类型管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="rawValue" placeholder="API类型名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="addButton" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editButton" class="edit-button">修改</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中"  style="width: 70%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="group_name" label="API类型名称" min-width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="seq" label="排序号" width="90">
        </el-table-column>
        <el-table-column prop="creater" label="创建人" width="200">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="135">
          <template slot-scope="scope">
            <div>{{scope.row.create_time|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-switch @change="changeStatus(scope.row.id,scope.row.status)"
                       v-model="scope.row.status"
                       :active-value="1"
                       :inactive-value="0"
                       active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="success" size="mini" style="margin-right: 8px"
                       @click="setApiData(scope.row.id)">
              配置API栏目
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="addDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="addForm" :rules="rules" ref="addForm" class="addForm">
        <el-form-item label="API类型" prop="group_name" class="relative r50">
          <el-input size="small" v-model="addForm.group_name" auto-complete="off" clearable maxlength="50"
                    placeholder="请输入API类型"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="seq" class="relative r50">
          <el-input size="small" v-model="addForm.seq" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入排序号"></el-input>
        </el-form-item>
        <el-form-item label="有效状态" prop="status" class="relative r50">
          <el-select v-model="addForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveButton('addForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>
      </span>
    </el-dialog>

<!--    配置API栏目-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="配置API栏目"
               :visible.sync="storeDialogVisible"
               width="40%"
               center>
      <div class="scrollbar mt20" style="max-height: 380px;overflow-y: auto">
        <el-table size="small" :data="modelData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 20px">
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column prop="sort_name" label="API栏目名称" min-width="135" :show-overflow-tooltip='true'>
            <template slot-scope="scope" style="position: relative">
              <el-input v-model="scope.row.sort_name" :disabled="!scope.row.isShow" placeholder="API栏目名称" maxLength="50"
                        clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="seq" label="排序号" width="120" >
            <template slot-scope="scope" style="position: relative">
              <el-input v-model="scope.row.seq" :disabled="!scope.row.isShow" placeholder="排序号" maxLength="8"
                        clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="220">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini"
                         @click.native.prevent="saveDetail(scope.row.id,scope.$index,scope.row.isShow)" v-if="scope.row.isShow"
                         style="width: 80px">保存
              </el-button>
              <el-button type="primary" plain size="mini"
                         @click.native.prevent="editDetail(scope.row.id,scope.$index,scope.row.isShow)" v-if="!scope.row.isShow"
                         style="width: 80px">编辑
              </el-button>
              <el-button type="danger" plain size="mini"
                         @click.native.prevent="deleteRow(scope.row.id,scope.$index, modelData)"
                         style="width: 80px">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="stions">
        <el-button type="primary" plain @click="addModelDetail" v-if="isShowAdd">新增API栏目名称</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    docGroupList,
    docGroupAdd,
    docGroupUpdate,
    docGroupDetail,
    docSortList,
    docSortAdd,
    docSortUpdate,
    docSortDelete
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'

  export default {
    data: () => {
      var validateSeq = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('排序号请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        addDialogVisible: false,  // 弹窗
        storeDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        modelData: [],
        formInline: {
          pageNo: 1,
          pageSize: 10,
          groupName: '',
          status: '',
        },
        rules: {
          group_name:[{required: true, message: '请输入API类型', trigger: 'blur'}],
          seq: [{required: true, validator: validateSeq, trigger: 'blur'}],
          status: [{required: true, message: '请选择有效状态', trigger: 'blur'}],
        },
        addForm: {
          id: '',
          group_name: '',
          seq: "",
          status: '',
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        isCanSubmit: true,
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        obj: {
          isShow: true
        },
        isShowAdd: true,
        groupId: '',
        rawValue:''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getData(this.formInline)
    },
    computed: {
        groupName: {
          // 当rawValue更新时，进行encodeURIComponent转换
          get() {
            return this.rawValue ? encodeURIComponent(this.rawValue) : '';
          },
          // 当输入框失去焦点时，更新rawValue，并对其进行decodeURIComponent转换
          set(value) {
            this.rawValue = value ? decodeURIComponent(value) : '';
          }
        }
    },
    methods: {
      // 新增API类型
      addButton() {
        this.addDialogVisible = true;
        this.dialogTitle = '新增API类型';
        this.addForm = {};
      },
      // 修改API类型
      editButton() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.dialogTitle = '修改API类型';
        this.addDialogVisible = true;
        docGroupDetail(this.selectTableData[0].id)
          .then(res => {
            if (res.success) {
              this.addForm = res.content;
            }
          })
          .catch(err => {
          })
        this.productId = this.selectTableData[0].id;
      },
      changeStatus(id, status) {
        if (!status) {
          let body = {
            id: id,
            status: 0
          }
          docGroupUpdate(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          let body = {
            id: id,
            status: 1
          }
          docGroupUpdate(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 获取公司列表
      getData(parameter) {
        this.loading = true;
        parameter.groupName = this.groupName;
        docGroupList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNo
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNo = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData(this.formInline)
      },
      // 新增动态属性
      saveButton(formName) {
        if (this.dialogTitle == '修改API类型') {
          this.addForm.id = this.productId;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增API类型') {
              docGroupAdd(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加API类型!'
                    });
                    this.handleClose()
                    this.getData(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              docGroupUpdate(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改API类型!'
                    });
                    this.handleClose()
                    this.getData(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 配置API栏目
      setApiData(id) {
        this.groupId = id;
        this.storeDialogVisible = true;
        this.isShowAdd = true;
        this.loading = true;
        this.modelData = [];
        if (id) {
          docSortList(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if (res.content.rows.length) {
                  res.content.rows.forEach((item) => {
                    item.isShow = false;
                    this.modelData.push(item)
                  })
                }
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 配置API栏目保存
      saveDetail(id,index) {
        if (!this.modelData[index].sort_name) {
          this.$message({
            type: 'info',
            message: 'API栏目名称不能为空'
          })
          return
        }
        if (!(/(^[1-9]\d*$)/.test(this.modelData[index].seq))) {
          this.$message.error('排序号请输入正整数');
          return
        }
        this.modelData[index].group_id = this.groupId;
        if(id) {
          this.modelData[index].id = id;
          docSortUpdate(this.modelData[index])
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改配置API栏目!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          docSortAdd(this.modelData[index])
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功新增配置API栏目!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
        this.isShowAdd = true;
        this.modelData[index].isShow = false
      },
      editDetail(id,index) {
        this.modelData[index].isShow = true
      },
      deleteRow(id, index, rows) {
        this.isShowAdd = true;
        console.log(id)
        if(id) {
          const title = '是否确认删除API栏目？';
          this.$confirm(title, '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let body = {
              id:id
            }
            docSortDelete(body)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  rows.splice(index, 1);
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else {
          rows.splice(index, 1);
        }
      },
      // 新增API栏目名称
      addModelDetail() {
        this.isShowAdd = false;
        this.modelData.push(JSON.parse(JSON.stringify(this.obj)))
      },
      // 搜索事件
      search() {
        this.formInline.pageNo = 1;
        this.getData(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["addForm"].resetFields();
        this.addDialogVisible = false;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.attr_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .addForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .addForm .el-input {
    width: 320px;
  }

  /deep/ .addForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .addForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .addForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .addForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .addForm .el-input--small {
    width: 320px;
  }

  /deep/ .pswd .el-input__inner {
    padding-right: 135px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .stions {
    border-bottom: 1px solid #EBEEF5;
    padding: 8px 2px;
    text-align: center;
  }

</style>





// WEBPACK FOOTER //
// src/views/Document/typeDocument.vue